import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { LogOut } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { PermissionsRequests } from "./request.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento da página de permissões
 */
export class PermissionsServices {
    constructor() {
        this.permissionsRequests = new PermissionsRequests();
    }

    // Busca dados da permissão com base no id
    async getPermission(id){
        try {
            const response = await this.permissionsRequests.getPermission(id);
            return response.data;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut())
            }
            return false
        }
    }

    // Edita a permissão com base no id
    async editPermission (Id, permission){
        try {
            const response = await this.permissionsRequests.editPermission(Id, permission);
            toast(i18n.t("message.permissions-service.response-edit-permission"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut())
            }
            return false
        }
    }

    // Busca todas permissões
    async getAllPermissions(search, page){
        try {
            const response = await this.permissionsRequests.getAllPermissions(search, page);
            return response
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut())
            }
            return []
        }
    }

    // Cria uma nova permissão
    async savePermission (permission){
        try {
            const response = await this.permissionsRequests.createPermission(permission);
            toast(i18n.t("message.permissions-service.response-save-permission"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut())
            }
            return false
        }
    }

    // Deleta permissão com base no id
    async deletePermission(id, navigate){
        try {
            const response = await this.permissionsRequests.deletePermission(id);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            navigate('/adm/permissoes')
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut())
            }
        }
    }
}